import { createSlice } from "@reduxjs/toolkit";
import {
  AllOrdersThunk,
  GetSingleOrdersThunk,
  AddOrdersThunk,
  UpdateOrdersThunk,
  DeleteOrdersThunk,
  GetSingleOrdersInvoiceThunk
} from "./thunk";

const initialState = {
  orders: [],
  singleOrder: null,
  singleinvoice: null,
  loading: false,
  error: null,
  successMessage: null,
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    clearOrderState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- ALL ORDERS --------------------
      .addCase(AllOrdersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllOrdersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload?.data || [];
      })
      .addCase(AllOrdersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE ORDER --------------------
      .addCase(GetSingleOrdersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleOrdersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleOrder = action.payload?.data || null;
      })
      .addCase(GetSingleOrdersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ADD ORDER --------------------
      .addCase(AddOrdersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddOrdersThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Order added successfully!";
      })
      .addCase(AddOrdersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- UPDATE ORDER --------------------
      .addCase(UpdateOrdersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateOrdersThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Order updated successfully!";
      })
      .addCase(UpdateOrdersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- DELETE ORDER --------------------
      .addCase(DeleteOrdersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteOrdersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = state.orders.filter((o) => o.uuid !== action.payload.uuid);
        state.successMessage = "Order deleted successfully!";
      })
      .addCase(DeleteOrdersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE ORDER INVOICE--------------------
      .addCase(GetSingleOrdersInvoiceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleOrdersInvoiceThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleinvoice = action.payload || null;
      })
      .addCase(GetSingleOrdersInvoiceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { clearOrderState } = ordersSlice.actions;
export default ordersSlice.reducer;
